// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.youtube-details-page {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;
}

.page-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 30px;
  border-radius: 12px;
  margin-bottom: 30px;
  position: relative;
}

.back-button {
  background: rgba(255, 255, 255, 0.2);
  color: white;
  border: 2px solid rgba(255, 255, 255, 0.3);
  padding: 8px 16px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s;
  margin-bottom: 15px;
}

.back-button:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: translateY(-1px);
}

.page-header h1 {
  margin: 0 0 8px 0;
  font-size: 2.5rem;
  font-weight: 700;
}

.project-title {
  margin: 0;
  font-size: 1.1rem;
  opacity: 0.9;
  font-weight: 400;
}

.loading {
  text-align: center;
  padding: 60px 20px;
  font-size: 1.2rem;
  color: #666;
}

.message {
  padding: 15px 20px;
  border-radius: 8px;
  margin-bottom: 20px;
  font-weight: 500;
  text-align: center;
}

.message.success {
  background-color: #d4edda;
  color: #155724;
  border: 1px solid #c3e6cb;
}

.message.error {
  background-color: #f8d7da;
  color: #721c24;
  border: 1px solid #f5c6cb;
}

.content-wrapper {
  display: flex;
  flex-direction: column;
  gap: 30px;
}

/* Section Styles */
section {
  background: white;
  border-radius: 12px;
  padding: 25px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
  border: 1px solid #e5e7eb;
}

section h2 {
  margin: 0 0 20px 0;
  color: #1f2937;
  font-size: 1.5rem;
  font-weight: 600;
  padding-bottom: 10px;
  border-bottom: 2px solid #f3f4f6;
}

/* Language Section */
.language-section {
  background: #f8fafc;
}

.language-select {
  width: 100%;
  max-width: 300px;
  padding: 12px 16px;
  border: 2px solid #d1d5db;
  border-radius: 8px;
  font-size: 16px;
  background: white;
  cursor: pointer;
  transition: border-color 0.2s;
}

.language-select:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

/* YouTube Details Section */
.generation-controls {
  margin-bottom: 25px;
}

.prompt-input {
  margin-bottom: 20px;
}

.prompt-input label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
  color: #374151;
}

.prompt-input-wrapper {
  display: flex;
  gap: 12px;
  align-items: flex-start;
}

.prompt-input textarea {
  flex: 1 1;
  padding: 12px 16px;
  border: 2px solid #d1d5db;
  border-radius: 8px;
  font-family: inherit;
  font-size: 14px;
  resize: vertical;
  transition: border-color 0.2s;
}

.prompt-input textarea:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.generate-prompt-button {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  color: white;
  border: none;
  padding: 12px 20px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.25);
  white-space: nowrap;
  min-height: 44px;
}

.generate-prompt-button:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(16, 185, 129, 0.3);
}

.generate-prompt-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.generate-button {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  padding: 14px 28px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.25);
}

.generate-button:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(102, 126, 234, 0.3);
}

.generate-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

/* YouTube Details Display */
.youtube-details-display {
  background: #f8fafc;
  border-radius: 8px;
  padding: 20px;
  border: 1px solid #e5e7eb;
}

.youtube-details-display h3 {
  margin: 0 0 20px 0;
  color: #1f2937;
  font-size: 1.3rem;
}

.detail-item {
  margin-bottom: 20px;
}

.detail-item label {
  display: block;
  margin-bottom: 8px;
  font-weight: 600;
  color: #374151;
  font-size: 14px;
}

.title-display {
  background: white;
  padding: 12px 16px;
  border-radius: 6px;
  border: 1px solid #d1d5db;
  font-weight: 500;
  color: #1f2937;
}

.description-display {
  background: white;
  padding: 16px;
  border-radius: 6px;
  border: 1px solid #d1d5db;
  line-height: 1.6;
  white-space: pre-wrap;
  max-height: 200px;
  overflow-y: auto;
}

.detail-meta {
  margin-top: 15px;
  padding-top: 15px;
  border-top: 1px solid #e5e7eb;
}

.detail-meta small {
  color: #6b7280;
  font-size: 13px;
}

.toggle-thumbnail-button {
  background: #059669;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
  margin-top: 15px;
}

.toggle-thumbnail-button:hover {
  background: #047857;
}

/* Thumbnail Section */
.thumbnail-section {
  background: #fef7ff;
  border-left: 4px solid #a855f7;
}

.thumbnail-generation {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.upload-section {
  background: white;
  padding: 20px;
  border-radius: 8px;
  border: 2px dashed #d1d5db;
}

.upload-section label {
  display: block;
  margin-bottom: 10px;
  font-weight: 600;
  color: #374151;
}

.file-input {
  width: 100%;
  padding: 12px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  cursor: pointer;
}

.upload-hint {
  margin: 8px 0 0 0;
  font-size: 13px;
  color: #6b7280;
  font-style: italic;
}

.selected-images {
  margin-top: 15px;
  padding: 12px;
  background: #f3f4f6;
  border-radius: 6px;
}

.selected-images p {
  margin: 0 0 8px 0;
  font-weight: 500;
  color: #374151;
}

.selected-images ul {
  margin: 0;
  padding-left: 20px;
}

.selected-images li {
  color: #6b7280;
  font-size: 13px;
}

.visual-prompt-section {
  background: white;
  padding: 20px;
  border-radius: 8px;
  border: 1px solid #d1d5db;
}

.visual-prompt-section label {
  display: block;
  margin-bottom: 10px;
  font-weight: 600;
  color: #374151;
}

.visual-prompt-section .prompt-input-wrapper {
  display: flex;
  gap: 12px;
  align-items: flex-start;
}

.visual-prompt-section textarea {
  flex: 1 1;
  padding: 12px 16px;
  border: 2px solid #d1d5db;
  border-radius: 8px;
  font-family: inherit;
  font-size: 14px;
  resize: vertical;
  transition: border-color 0.2s;
}

.visual-prompt-section textarea:focus {
  outline: none;
  border-color: #a855f7;
  box-shadow: 0 0 0 3px rgba(168, 85, 247, 0.1);
}

.generate-thumbnail-button {
  background: linear-gradient(135deg, #a855f7 0%, #ec4899 100%);
  color: white;
  border: none;
  padding: 14px 28px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: 0 4px 12px rgba(168, 85, 247, 0.25);
}

.generate-thumbnail-button:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(168, 85, 247, 0.3);
}

.generate-thumbnail-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

/* Thumbnails List */
.thumbnails-list-section {
  background: #fafafa;
}

.no-thumbnails {
  text-align: center;
  color: #6b7280;
  font-style: italic;
  padding: 40px 20px;
}

.thumbnails-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 20px;
}

.thumbnail-item {
  background: white;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  border: 1px solid #e5e7eb;
  transition: transform 0.2s, box-shadow 0.2s;
}

.thumbnail-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.thumbnail-info h4 {
  margin: 0 0 12px 0;
  color: #1f2937;
  font-size: 1.1rem;
}

.thumbnail-info p {
  margin: 4px 0;
  color: #6b7280;
  font-size: 13px;
}

.thumbnail-actions {
  margin-top: 15px;
  display: flex;
  gap: 10px;
}

.view-button {
  background: #3b82f6;
  color: white;
  padding: 8px 16px;
  border-radius: 5px;
  text-decoration: none;
  font-size: 13px;
  font-weight: 500;
  transition: background-color 0.2s;
}

.view-button:hover {
  background: #2563eb;
  color: white;
}

.delete-button {
  background: #dc2626;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 5px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
}

.delete-button:hover {
  background: #b91c1c;
}

/* Responsive Design */
@media (max-width: 768px) {
  .youtube-details-page {
    padding: 15px;
  }
  
  .page-header {
    padding: 20px;
  }
  
  .page-header h1 {
    font-size: 2rem;
  }
  
  section {
    padding: 20px;
  }
  
  .prompt-input-wrapper,
  .visual-prompt-section .prompt-input-wrapper {
    flex-direction: column;
    align-items: stretch;
  }
  
  .generate-prompt-button {
    align-self: flex-end;
    width: fit-content;
  }
  
  .thumbnails-grid {
    grid-template-columns: 1fr;
  }
  
  .thumbnail-actions {
    flex-direction: column;
  }
}

@media (max-width: 480px) {
  .youtube-details-page {
    padding: 10px;
  }
  
  .page-header {
    padding: 15px;
  }
  
  .page-header h1 {
    font-size: 1.5rem;
  }
  
  section {
    padding: 15px;
  }
}`, "",{"version":3,"sources":["webpack://./src/YouTubeDetailsPage.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,gFAAgF;AAClF;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,0CAA0C;EAC1C,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,mBAAmB;AACnB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA,qBAAqB;AACrB;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA,4BAA4B;AAC5B;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,+CAA+C;EAC/C,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,gDAAgD;AAClD;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA,4BAA4B;AAC5B;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,+CAA+C;AACjD;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,wCAAwC;EACxC,yBAAyB;EACzB,2CAA2C;AAC7C;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;;IAEE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,oBAAoB;IACpB,kBAAkB;EACpB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[".youtube-details-page {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 20px;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;\n}\n\n.page-header {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  padding: 30px;\n  border-radius: 12px;\n  margin-bottom: 30px;\n  position: relative;\n}\n\n.back-button {\n  background: rgba(255, 255, 255, 0.2);\n  color: white;\n  border: 2px solid rgba(255, 255, 255, 0.3);\n  padding: 8px 16px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  transition: all 0.2s;\n  margin-bottom: 15px;\n}\n\n.back-button:hover {\n  background: rgba(255, 255, 255, 0.3);\n  transform: translateY(-1px);\n}\n\n.page-header h1 {\n  margin: 0 0 8px 0;\n  font-size: 2.5rem;\n  font-weight: 700;\n}\n\n.project-title {\n  margin: 0;\n  font-size: 1.1rem;\n  opacity: 0.9;\n  font-weight: 400;\n}\n\n.loading {\n  text-align: center;\n  padding: 60px 20px;\n  font-size: 1.2rem;\n  color: #666;\n}\n\n.message {\n  padding: 15px 20px;\n  border-radius: 8px;\n  margin-bottom: 20px;\n  font-weight: 500;\n  text-align: center;\n}\n\n.message.success {\n  background-color: #d4edda;\n  color: #155724;\n  border: 1px solid #c3e6cb;\n}\n\n.message.error {\n  background-color: #f8d7da;\n  color: #721c24;\n  border: 1px solid #f5c6cb;\n}\n\n.content-wrapper {\n  display: flex;\n  flex-direction: column;\n  gap: 30px;\n}\n\n/* Section Styles */\nsection {\n  background: white;\n  border-radius: 12px;\n  padding: 25px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);\n  border: 1px solid #e5e7eb;\n}\n\nsection h2 {\n  margin: 0 0 20px 0;\n  color: #1f2937;\n  font-size: 1.5rem;\n  font-weight: 600;\n  padding-bottom: 10px;\n  border-bottom: 2px solid #f3f4f6;\n}\n\n/* Language Section */\n.language-section {\n  background: #f8fafc;\n}\n\n.language-select {\n  width: 100%;\n  max-width: 300px;\n  padding: 12px 16px;\n  border: 2px solid #d1d5db;\n  border-radius: 8px;\n  font-size: 16px;\n  background: white;\n  cursor: pointer;\n  transition: border-color 0.2s;\n}\n\n.language-select:focus {\n  outline: none;\n  border-color: #667eea;\n  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n}\n\n/* YouTube Details Section */\n.generation-controls {\n  margin-bottom: 25px;\n}\n\n.prompt-input {\n  margin-bottom: 20px;\n}\n\n.prompt-input label {\n  display: block;\n  margin-bottom: 8px;\n  font-weight: 500;\n  color: #374151;\n}\n\n.prompt-input-wrapper {\n  display: flex;\n  gap: 12px;\n  align-items: flex-start;\n}\n\n.prompt-input textarea {\n  flex: 1;\n  padding: 12px 16px;\n  border: 2px solid #d1d5db;\n  border-radius: 8px;\n  font-family: inherit;\n  font-size: 14px;\n  resize: vertical;\n  transition: border-color 0.2s;\n}\n\n.prompt-input textarea:focus {\n  outline: none;\n  border-color: #667eea;\n  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n}\n\n.generate-prompt-button {\n  background: linear-gradient(135deg, #10b981 0%, #059669 100%);\n  color: white;\n  border: none;\n  padding: 12px 20px;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.25);\n  white-space: nowrap;\n  min-height: 44px;\n}\n\n.generate-prompt-button:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 20px rgba(16, 185, 129, 0.3);\n}\n\n.generate-prompt-button:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: none;\n}\n\n.generate-button {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  border: none;\n  padding: 14px 28px;\n  border-radius: 8px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.25);\n}\n\n.generate-button:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 20px rgba(102, 126, 234, 0.3);\n}\n\n.generate-button:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: none;\n}\n\n/* YouTube Details Display */\n.youtube-details-display {\n  background: #f8fafc;\n  border-radius: 8px;\n  padding: 20px;\n  border: 1px solid #e5e7eb;\n}\n\n.youtube-details-display h3 {\n  margin: 0 0 20px 0;\n  color: #1f2937;\n  font-size: 1.3rem;\n}\n\n.detail-item {\n  margin-bottom: 20px;\n}\n\n.detail-item label {\n  display: block;\n  margin-bottom: 8px;\n  font-weight: 600;\n  color: #374151;\n  font-size: 14px;\n}\n\n.title-display {\n  background: white;\n  padding: 12px 16px;\n  border-radius: 6px;\n  border: 1px solid #d1d5db;\n  font-weight: 500;\n  color: #1f2937;\n}\n\n.description-display {\n  background: white;\n  padding: 16px;\n  border-radius: 6px;\n  border: 1px solid #d1d5db;\n  line-height: 1.6;\n  white-space: pre-wrap;\n  max-height: 200px;\n  overflow-y: auto;\n}\n\n.detail-meta {\n  margin-top: 15px;\n  padding-top: 15px;\n  border-top: 1px solid #e5e7eb;\n}\n\n.detail-meta small {\n  color: #6b7280;\n  font-size: 13px;\n}\n\n.toggle-thumbnail-button {\n  background: #059669;\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.2s;\n  margin-top: 15px;\n}\n\n.toggle-thumbnail-button:hover {\n  background: #047857;\n}\n\n/* Thumbnail Section */\n.thumbnail-section {\n  background: #fef7ff;\n  border-left: 4px solid #a855f7;\n}\n\n.thumbnail-generation {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.upload-section {\n  background: white;\n  padding: 20px;\n  border-radius: 8px;\n  border: 2px dashed #d1d5db;\n}\n\n.upload-section label {\n  display: block;\n  margin-bottom: 10px;\n  font-weight: 600;\n  color: #374151;\n}\n\n.file-input {\n  width: 100%;\n  padding: 12px;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  cursor: pointer;\n}\n\n.upload-hint {\n  margin: 8px 0 0 0;\n  font-size: 13px;\n  color: #6b7280;\n  font-style: italic;\n}\n\n.selected-images {\n  margin-top: 15px;\n  padding: 12px;\n  background: #f3f4f6;\n  border-radius: 6px;\n}\n\n.selected-images p {\n  margin: 0 0 8px 0;\n  font-weight: 500;\n  color: #374151;\n}\n\n.selected-images ul {\n  margin: 0;\n  padding-left: 20px;\n}\n\n.selected-images li {\n  color: #6b7280;\n  font-size: 13px;\n}\n\n.visual-prompt-section {\n  background: white;\n  padding: 20px;\n  border-radius: 8px;\n  border: 1px solid #d1d5db;\n}\n\n.visual-prompt-section label {\n  display: block;\n  margin-bottom: 10px;\n  font-weight: 600;\n  color: #374151;\n}\n\n.visual-prompt-section .prompt-input-wrapper {\n  display: flex;\n  gap: 12px;\n  align-items: flex-start;\n}\n\n.visual-prompt-section textarea {\n  flex: 1;\n  padding: 12px 16px;\n  border: 2px solid #d1d5db;\n  border-radius: 8px;\n  font-family: inherit;\n  font-size: 14px;\n  resize: vertical;\n  transition: border-color 0.2s;\n}\n\n.visual-prompt-section textarea:focus {\n  outline: none;\n  border-color: #a855f7;\n  box-shadow: 0 0 0 3px rgba(168, 85, 247, 0.1);\n}\n\n.generate-thumbnail-button {\n  background: linear-gradient(135deg, #a855f7 0%, #ec4899 100%);\n  color: white;\n  border: none;\n  padding: 14px 28px;\n  border-radius: 8px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n  box-shadow: 0 4px 12px rgba(168, 85, 247, 0.25);\n}\n\n.generate-thumbnail-button:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 20px rgba(168, 85, 247, 0.3);\n}\n\n.generate-thumbnail-button:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: none;\n}\n\n/* Thumbnails List */\n.thumbnails-list-section {\n  background: #fafafa;\n}\n\n.no-thumbnails {\n  text-align: center;\n  color: #6b7280;\n  font-style: italic;\n  padding: 40px 20px;\n}\n\n.thumbnails-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n  gap: 20px;\n}\n\n.thumbnail-item {\n  background: white;\n  border-radius: 8px;\n  padding: 20px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  border: 1px solid #e5e7eb;\n  transition: transform 0.2s, box-shadow 0.2s;\n}\n\n.thumbnail-item:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n}\n\n.thumbnail-info h4 {\n  margin: 0 0 12px 0;\n  color: #1f2937;\n  font-size: 1.1rem;\n}\n\n.thumbnail-info p {\n  margin: 4px 0;\n  color: #6b7280;\n  font-size: 13px;\n}\n\n.thumbnail-actions {\n  margin-top: 15px;\n  display: flex;\n  gap: 10px;\n}\n\n.view-button {\n  background: #3b82f6;\n  color: white;\n  padding: 8px 16px;\n  border-radius: 5px;\n  text-decoration: none;\n  font-size: 13px;\n  font-weight: 500;\n  transition: background-color 0.2s;\n}\n\n.view-button:hover {\n  background: #2563eb;\n  color: white;\n}\n\n.delete-button {\n  background: #dc2626;\n  color: white;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 5px;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.delete-button:hover {\n  background: #b91c1c;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .youtube-details-page {\n    padding: 15px;\n  }\n  \n  .page-header {\n    padding: 20px;\n  }\n  \n  .page-header h1 {\n    font-size: 2rem;\n  }\n  \n  section {\n    padding: 20px;\n  }\n  \n  .prompt-input-wrapper,\n  .visual-prompt-section .prompt-input-wrapper {\n    flex-direction: column;\n    align-items: stretch;\n  }\n  \n  .generate-prompt-button {\n    align-self: flex-end;\n    width: fit-content;\n  }\n  \n  .thumbnails-grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .thumbnail-actions {\n    flex-direction: column;\n  }\n}\n\n@media (max-width: 480px) {\n  .youtube-details-page {\n    padding: 10px;\n  }\n  \n  .page-header {\n    padding: 15px;\n  }\n  \n  .page-header h1 {\n    font-size: 1.5rem;\n  }\n  \n  section {\n    padding: 15px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
